const MODULES = {
  DASHBOARD: 1,
  // PRODUCT: 2,
  VENDOR: 3,
  USER: 4,
  BOM: 5,
  TYPEOFSALES: 6,
  PRODUCTIONPLANNING: 7,
  CATEGORY: 9,

  // QUALITY_CHECK: 8,
  BRAND: 10,
  COLOR: 11,
  PRODUCTTYPE: 12,
  // BATCHLIST: 13,
  // PRODUCTQC: 14,
  STOCK_IN: 15,
  STOCK_OUT: 16,
  ITEMTYPE: 17,
  COMPONENT: 18,
  DEPARTMENT: 20,
  // SETTINGS: 21,
  GRN: 22,
  // GENERATEQR: 23,
  REJECTION_REASON: 24,
  MAC_ADDRESS: 25,
  QC_RESULT: 26,

  QC_TEST_CASE: 27,
  QC_DASHBOARD: 28,
  INVENTORY_MASTER: 29,
  SPECIAL_MARKING: 30,
  ASSET: 31,
  MATERIAL_REQUEST: 32,
  VERSIONS: 33,
  LOCATION_MASTER: 34,
  DEVICE_QC: 35,
  PURCHASE_REQUEST: 36,
  DEVICE_QC_DASHBOARD: 37,
  PRODUCT_SUB_CATEGORY: 38,
};

export default MODULES;

export const MODULES_ACTION = {
  CREATE: 1,
  UPDATE: 2,
  DELETE: 3,
};

export const MODULE_ACTION_MAP = {
  VENDOR: [MODULES_ACTION.CREATE, MODULES_ACTION.UPDATE, MODULES_ACTION.DELETE],
  BOM: [MODULES_ACTION.CREATE, MODULES_ACTION.UPDATE, MODULES_ACTION.DELETE],
  TYPEOFSALES: [
    MODULES_ACTION.CREATE,
    MODULES_ACTION.UPDATE,
    MODULES_ACTION.DELETE,
  ],
  PRODUCTIONPLANNING: [
    MODULES_ACTION.CREATE,
    MODULES_ACTION.UPDATE,
    MODULES_ACTION.DELETE,
  ],
  CATEGORY: [
    MODULES_ACTION.CREATE,
    MODULES_ACTION.UPDATE,
    MODULES_ACTION.DELETE,
  ],
  PRODUCT_SUB_CATEGORY: [
    MODULES_ACTION.CREATE,
    MODULES_ACTION.UPDATE,
    MODULES_ACTION.DELETE,
  ],
  BRAND: [MODULES_ACTION.CREATE, MODULES_ACTION.UPDATE, MODULES_ACTION.DELETE],
  COLOR: [MODULES_ACTION.CREATE, MODULES_ACTION.UPDATE, MODULES_ACTION.DELETE],
  PRODUCTTYPE: [
    MODULES_ACTION.CREATE,
    MODULES_ACTION.UPDATE,
    MODULES_ACTION.DELETE,
  ],
  STOCK_IN: [MODULES_ACTION.CREATE],
  STOCK_OUT: [MODULES_ACTION.CREATE, MODULES_ACTION.UPDATE],
  ITEMTYPE: [
    MODULES_ACTION.CREATE,
    MODULES_ACTION.UPDATE,
    MODULES_ACTION.DELETE,
  ],
  COMPONENT: [
    MODULES_ACTION.CREATE,
    MODULES_ACTION.UPDATE,
    MODULES_ACTION.DELETE,
  ],
  DEPARTMENT: [
    MODULES_ACTION.CREATE,
    MODULES_ACTION.UPDATE,
    MODULES_ACTION.DELETE,
  ],
  GRN: [MODULES_ACTION.CREATE, MODULES_ACTION.UPDATE],
  REJECTION_REASON: [
    MODULES_ACTION.CREATE,
    MODULES_ACTION.UPDATE,
    MODULES_ACTION.DELETE,
  ],

  QC_TEST_CASE: [
    MODULES_ACTION.CREATE,
    MODULES_ACTION.UPDATE,
    MODULES_ACTION.DELETE,
  ],
  INVENTORY_MASTER: [
    MODULES_ACTION.CREATE,
    MODULES_ACTION.UPDATE,
    MODULES_ACTION.DELETE,
  ],
  SPECIAL_MARKING: [
    MODULES_ACTION.CREATE,
    MODULES_ACTION.UPDATE,
    MODULES_ACTION.DELETE,
  ],
  ASSET: [MODULES_ACTION.CREATE, MODULES_ACTION.UPDATE, MODULES_ACTION.DELETE],
  USER: [MODULES_ACTION.CREATE],
  VERSIONS: [MODULES_ACTION.CREATE, MODULES_ACTION.DELETE],
  LOCATION_MASTER: [
    MODULES_ACTION.CREATE,
    MODULES_ACTION.UPDATE,
    MODULES_ACTION.DELETE,
  ],

  DASHBOARD: [],
  MATERIAL_REQUEST: [
    MODULES_ACTION.CREATE,
    MODULES_ACTION.UPDATE,
    MODULES_ACTION.DELETE,
  ],
  MAC_ADDRESS: [],
  QC_RESULT: [],
  QC_DASHBOARD: [],
  // SETTINGS: [],
  // QUALITY_CHECK: [],
  // BATCHLIST: [],
  // PRODUCTQC: [],
  // GENERATEQR: [],
  // PRODUCT: [],
};
